import { z } from 'zod';

import packageJson from '../../package.json';

import { DEV_ENV_CONFIGS, getSelectedDevEnv } from './devEnvironments';
import { localEnvironment } from './localEnvironment';

export const ENVIRONMENTS = [
  'development',
  'beta',
  'staging',
  'production',
] as const;
export type Environment = (typeof ENVIRONMENTS)[number];

// The Zod .url() method is not working properly and accepts kind of everything :-(
const UrlSchema = z.string().trim().startsWith('http');

const zodEnvironmentSchema = z.object({
  apiUrl: UrlSchema,
  contactPageUrl: UrlSchema,
  environment: z.enum(ENVIRONMENTS),
  gitHash: z.string().trim().length(8).optional(),
  muiLicenseKey: z.string().trim(),
  sentryDsn: UrlSchema.includes('ingest.de.sentry.io'),
  sgwUrl: UrlSchema.endsWith('/db'),
  version: z.string().trim(),
});
export type EnvironmentVariables = z.infer<typeof zodEnvironmentSchema>;

const isDev = import.meta.env.VITE_ENV === 'development';
const devOverride = isDev ? DEV_ENV_CONFIGS[getSelectedDevEnv()] : null;

const validatedEnvironmentVariables = zodEnvironmentSchema.parse({
  apiUrl:
    localEnvironment.VITE_LOCAL_API_URL ||
    devOverride?.apiUrl ||
    import.meta.env.VITE_API_URL,
  contactPageUrl:
    devOverride?.contactPageUrl ?? import.meta.env.VITE_CONTACT_PAGE_URL,
  environment: import.meta.env.VITE_ENV,
  gitHash: import.meta.env.VITE_GIT_HASH,
  muiLicenseKey: import.meta.env.VITE_MUI_LICENSE_KEY,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  sgwUrl: devOverride?.sgwUrl ?? import.meta.env.VITE_SGW_URL,
  version: packageJson.version,
});

export const {
  apiUrl,
  contactPageUrl,
  environment,
  gitHash,
  muiLicenseKey,
  sentryDsn,
  sgwUrl,
  version,
} = validatedEnvironmentVariables;
